export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
  RESET = 'RESET'
}

export interface ListConductorSort {
  [key: string]: SortDirection;
}

export const getRawSortData = (sort: ListConductorSort) => {
  return Object.entries(sort).map(([key, value]) => {
    return {
      field: key,
      order: value as string
    };
  });
};
